import * as React from 'react';
import styles from './index.module.css';
import { cn } from '@/lib/utils';

// All possible variants
type Variant =
  | 'primary'
  | 'secondary'
  | 'secondary_black'
  | 'link'
  | 'linkDanger'
  | 'tertiary'
  | 'grey'
  | 'chip'
  | 'chipSelected';

interface LoadingDotsProps {
  variant: Variant; // Variants of the button UI component
}

const LoadingDots: React.FC<LoadingDotsProps> = ({ variant }) => {
  // Map variant to CSS module animation classes
  const animationClass = {
    primary: styles.animationPrimary,
    secondary: styles.animationSecondary,
    secondary_black: styles.animationSecondaryBlack,
    link: styles.animationLink,
    linkDanger: styles.animationLinkDanger,
    tertiary: styles.animationPrimary,
    grey: styles.animationPrimary,
    chip: styles.animationPrimary,
    chipSelected: styles.animationPrimary,
  }[variant];

  return (
    <div className="flex items-center justify-center gap-2" role="status">
      {[0, 1, 2].map((index) => (
        <div
          key={index}
          className={cn(
            'size-[0.5rem] rounded-[50%]',
            animationClass, // Variant-specific animation
            styles[`delay${index}`] // Staggered animation delay
          )}
        />
      ))}
    </div>
  );
};

export default LoadingDots;
